import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=bfaa28d4&scoped=true&"
import script from "./LoginView.vue?vue&type=script&lang=js&"
export * from "./LoginView.vue?vue&type=script&lang=js&"
import style0 from "./LoginView.vue?vue&type=style&index=0&id=bfaa28d4&lang=scss&scoped=true&"
import style1 from "./LoginView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfaa28d4",
  null
  
)

export default component.exports